// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { DealerStateContext } from "@insite/client-framework/Store/Data/Dealers/DealersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import parse from "html-react-parser";
import React, { useContext } from "react";

export interface DealerContentStyles {}

export const dealerContentStyles: DealerContentStyles = {};

const styles = dealerContentStyles;

const DealerContent: React.FC = () => {
    const { value: dealer } = useContext(DealerStateContext);
    if (!dealer || !dealer.htmlContent) {
        return null;
    }

    return (
        <GridContainer gap={0} data-test-selector="dealerContent">
            <GridItem width={12}>
                <StyledWrapper data-test-selector="dealerInformation_htmlContent">
                    {parse(dealer.htmlContent, parserOptions)}
                </StyledWrapper>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: DealerContent,
    definition: {
        allowedContexts: ["DealerDetailsPage"],
        group: "Dealer Details",
    },
};

export default widgetModule;
